import { Storage } from 'aws-amplify';

export const S3GET = (key, level = 'public') => Storage.get(key, { level });

export const S3PUT = (key, body, contentType, level = 'public') =>
    Storage.put(key, body, { level, contentType });
